import { useCallback } from 'react'
import type { EditActivityForm } from '../typings'
import { FormikErrors } from 'formik'
import { getHours, getMinutes, isAfter, isEqual, set } from 'date-fns/esm'

function constructDate(date: Date | number | null, time: Date | number | null) {
  return !!date
    ? !!time
      ? set(date, {
          hours: getHours(time),
          minutes: getMinutes(time),
        })
      : new Date(date)?.setHours(0, 0, 0)
    : null
}

export function useValidations() {
  const validate = useCallback((model: EditActivityForm) => {
    const {
      subject,
      startDate,
      dueDate,
      startTime,
      dueTime,
      activityTypeId,
      ownerId,
    } = model
    const errors: FormikErrors<EditActivityForm> = {}

    const constructedStartDate = constructDate(startDate, startTime)
    const constructedDueDate = constructDate(dueDate, dueTime)

    if (!subject) {
      errors.subject = 'Required'
    }

    if (!activityTypeId) {
      errors.activityTypeId = 'Required'
    }

    if (!ownerId) {
      errors.ownerId = 'Required'
    }

    if (!dueDate) {
      errors.dueDate = 'Required'
    } else if (
      startDate &&
      dueDate &&
      (isAfter(constructedStartDate || 0, constructedDueDate || 0) ||
        isEqual(constructedDueDate || 0, constructedStartDate || 0))
    ) {
      errors.dueDate = 'Must be after start date'
    } else if (dueDate.toString() === 'Invalid Date') {
      errors.dueDate = 'Invalid date format'
    }

    if (!dueTime) {
      errors.dueTime = 'Required'
    }

    if (startDate && startDate.toString() === 'Invalid Date') {
      errors.startDate = 'Invalid date format'
    }

    if (startDate && !startTime) {
      errors.startTime = 'Required'
    }

    return errors
  }, [])

  return { validate }
}
